import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppResource } from 'src/app/app.resource';
import { State } from 'src/app/core/state/core.state';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';

@Component({
  selector: 'app-amendment-confirmation',
  templateUrl: './amendment-confirmation.component.html',
  styleUrls: ['./amendment-confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AmendmentConfirmationComponent extends BaseComponent implements OnInit {
  constructor(store: Store<State>, resources: AppResource) {
    super(store, resources);
  }
}
